module.exports = __webpack_public_path__ + "img/animals_goat.865a219c.png";